import { SUBMIT_LOCK_MS } from '#pplx/frontend/composer-sdk/submitLock.js';
import { useCallback, useEffect, useRef } from 'react';
/**
 * Returns a gate for submit attempts. A `true` result admits the attempt;
 * further calls return `false` for one second, including after a rejected submit.
 */
export function useSubmitLock() {
    const isSubmittingRef = useRef(false);
    const submitLockTimerRef = useRef(null);
    useEffect(() => () => {
        if (submitLockTimerRef.current !== null) {
            clearTimeout(submitLockTimerRef.current);
        }
        isSubmittingRef.current = false;
    }, []);
    return useCallback(() => {
        if (isSubmittingRef.current) {
            return false;
        }
        // Lock in the gesture's task: a controlled draft clear may commit after a second tap.
        isSubmittingRef.current = true;
        submitLockTimerRef.current = setTimeout(() => {
            isSubmittingRef.current = false;
            submitLockTimerRef.current = null;
        }, SUBMIT_LOCK_MS);
        return true;
    }, []);
}
//# sourceMappingURL=useSubmitLock.js.map